<template>
  <div>
    <template v-if="tailwind">
    <!-- template with Tailwind -->
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Regulatory keys benchmark performance chart</h1>
          <p data-v-1707ada0="" class="mt-1 text-sm leading-6 text-gray-600">{{accountName}}</p>
        </div>
      </div>
      <form @submit.prevent="getDataTrackPerformance" class="md:col-span-2">
        <div class="p-2">
          <div class="grid grid-cols-6 gap-x-6 gap-y-8">
            <div>
              <label for="start_date"  class="block text-sm font-medium leading-6 text-gray-900">Start Date:</label>
              <div class="mt-2">
                <VueDatePicker
                    v-model="startDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                    format="dd.MM.yyyy"
                    :enable-time-picker="false"
                    :month-change-on-scroll="false"
                    :clearable="false"
                    auto-apply
                    position="left"
                    id="start_date"
                ></VueDatePicker>
              </div>
            </div>

            <div>
              <label for="end_date" class="block text-sm font-medium leading-6 text-gray-900">End Date:</label>
              <div class="mt-2">
                <VueDatePicker
                    v-model="endDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                    format="dd.MM.yyyy"
                    :enable-time-picker="false"
                    :month-change-on-scroll="false"
                    :clearable="false"
                    auto-apply
                    position="left"
                    id="start_date"
                ></VueDatePicker>
              </div>
            </div>

            <div>
              <label for="reg_key" class="block text-sm font-medium leading-6 text-gray-900">Reg key:&nbsp;</label>
              <div class="mt-2">
                <v-select
                    id="reg_key"
                    v-model="currentRegKey"
                    label="title"
                    :reduce="RegKey => RegKey"
                    :options="regKeyOptions"
                    taggable
                    placeholder="All">
                </v-select>
                <input type="hidden" v-model="currentRegKey" name="reg_key" />
              </div>
            </div>

            <div>
              <div class="mt-9">
              <label class="block text-sm font-medium leading-6 text-gray-900">
                <input type="checkbox" v-model="industryBenchmarkEnabled" @change="getDataTrackPerformance('industry_benchmark')"> Industry Benchmark
              </label>
              </div>
            </div>

            <div class="flex items-end">
              <button @click="initializeDates" type="button" class="rounded-md bg-white px-3 py-2 mr-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50" style="padding: 7px"><i class="fa fa-rotate-left"></i></button>
              <button type="submit" class="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Filter</button>
            </div>
          </div>
        </div>
      </form>

      <div class="graph_track_performance_tailwind">
        <Line
            :options="chartOptionsLine"
            :data="chartDataLine"
        />
      </div>

    </template>
    <template v-else>
      <h3>Regulatory keys benchmark performance chart</h3>
      <form @submit.prevent="getDataTrackPerformance" class="form-inline">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="start_date" class="control-label">Start Date: </label>
              <VueDatePicker
                  v-model="startDate"
                  :min-date="minDate"
                  :max-date="maxDate"
                  format="dd.MM.yyyy"
                  :enable-time-picker="false"
                  :month-change-on-scroll="false"
                  :clearable="false"
                  auto-apply
                  position="left"
                  id="start_date"
              ></VueDatePicker>
            </div>

            <div class="form-group">
              <label for="end_date" class="control-label">End Date:&nbsp;</label>
              <VueDatePicker
                  v-model="endDate"
                  :min-date="minDate"
                  :max-date="maxDate"
                  format="dd.MM.yyyy"
                  :enable-time-picker="false"
                  :month-change-on-scroll="false"
                  :clearable="false"
                  auto-apply
                  position="left"
                  id="start_date"
              ></VueDatePicker>
            </div>
            <div class="form-group">
              <label for="reg_key" class="control-label">Reg key:&nbsp;</label>
              <v-select
                  id="reg_key"
                  v-model="currentRegKey"
                  label="title"
                  :reduce="RegKey => RegKey"
                  :options="regKeyOptions"
                  taggable
                  placeholder="All">
              </v-select>
              <input type="hidden" v-model="currentRegKey" name="reg_key" />
            </div>
            <div class="form-group">
              <br>
              <button @click="initializeDates" type="button" class="btn btn-primary" style="padding: 7px"><i class="fa fa-rotate-left"></i></button>
            </div>
            <div class="form-group">
              <br>
              <button type="submit" class="btn btn-primary">Filter</button>
            </div>
          </div>
          <div class="col-md-12">
            <label>
              <input type="checkbox" v-model="industryBenchmarkEnabled" @change="getDataTrackPerformance('industry_benchmark')"> Industry Benchmark
            </label>
          </div>
        </div>
        <hr>
      </form>
      <div class="graph_track_performance">
        <Line
            :options="chartOptionsLine"
            :data="chartDataLine"
        />
      </div>
    </template>
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'

import { Line } from 'vue-chartjs'

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
)

export default {
  name: 'TrackPerformanceComponent',
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    tailwind: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    // Bar,
    Line
  },
  data() {
    return {
      startDate: '',
      endDate: '',
      minDate: '',
      maxDate: '',
      chartDataLine: {
        labels: [],
        datasets: []
      },
      chartOptionsLine: {
        responsive: true,
        scales: {
          y: {
            min: 0,
            max: 100
          }
        }
      },
      accountName: null,
      currentRegKey: null,
      regKeyOptions: [],
      industryBenchmarkEnabled: false,
    }
  },
  created() {
    this.initializeDates();
  },
  methods: {
    initializeDates() {
      this.industryBenchmarkEnabled = false;
      let path = `/track-performance-data/${this.accountId}`;

      axios.get(path)
          .then(res => {
            const { scores, min_date, max_date, account_name, current_reg_key, reg_keys } = res.data;
            this.minDate = min_date;
            this.maxDate = max_date;
            this.startDate = min_date;
            this.endDate = max_date;
            this.chartDataLine = scores;
            this.accountName = account_name;
            this.currentRegKey = current_reg_key;
            this.regKeyOptions = reg_keys;
          })
          .catch(err => {
            console.error(err);
          });
    },

    getDataTrackPerformance(option = 'default') {
      let path = `/track-performance-data/${this.accountId}`;

      const params = {
        current_reg_key: this.currentRegKey,
        industry_benchmark_enabled: this.industryBenchmarkEnabled,
      };

      if (option !== 'industry_benchmark') {
        const formattedStartDate = this.formatDate(this.startDate);
        const formattedEndDate = this.formatDate(this.endDate);

        params.start_date = formattedStartDate;
        params.end_date = formattedEndDate;
      }

      axios.get(path, { params })
          .then(res => {
            const { scores, min_date, max_date, account_name, current_reg_key, reg_keys } = res.data;
            if (option === 'industry_benchmark') {
              this.minDate = min_date;
              this.maxDate = max_date;
              this.startDate = min_date;
              this.endDate = max_date;
            }
            this.chartDataLine = scores;
            this.accountName = account_name;
            this.currentRegKey = current_reg_key;
            this.regKeyOptions = reg_keys;
            console.log(this.minDate, this.maxDate, this.startDate, this.endDate);
          })
          .catch(err => {
            console.error(err);
          });
    },

    formatDate(date) {
      const d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      let year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    },
  }
}
</script>

<style>
.form-group {
  margin-right: 10px;
}
</style>